import React from 'react';
import {Helmet} from "react-helmet";
import Layout from '../components/Layout';
import AudiForm from '../components/AudiForm';
import Disclaimer from '../components/Disclaimer';
import Button from '../audi-ui-components/Button';
import { formatMobile } from '../functions/textFormatting';
import { request, prefCentreService } from '../functions/apiRequestHelper';
import { gtmPageview } from '../functions/gtm';
import queryString from 'query-string';
import {
    UI_AUDI_MIN,
    PATH_ADE_WAITLIST,
    PATH_THANKS,
    STATES_OPTIONS,
    FIELD_TEXT,
    FIELD_TEXTAREA,
    FIELD_CHECKBOX,
    FIELD_DROPDOWN,
    DEFAULT_THEME,
} from '../constants';

class ADEWaitlist extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            isFetchingUser: true,
            expCourse: "",
            expLoc: "",
            expDate: null,
            expDateFormatted: "",
            expError: false,
            isFetchingExp: true,
            submitted: false,
            submittedData: {},
            hideFieldTravel: true
        }
    }

    componentDidMount() {
        const {match, location} = this.props;
        const query = queryString.parse(location.search);
        if (match.params.expId) {
            request(process.env.RAZZLE_ADE_API, {
                path: `1/experiences/${match.params.expId}`
            }).then((data) => {
                // console.log(data);
                if (data && data.id) {
                    let d = new Date(data.startDate);
                    this.setState({
                        isFetchingExp: false,
                        expCourse: data.program.name,
                        expLoc: data.venue.location,
                        expDate: data.startDate,
                        expDateFormatted: d.toLocaleDateString("en-US", {year: "numeric", month: "short", day: "numeric"})
                    });
                } else {
                    this.setState({isFetchingExp: false, expError: true});
                }
            }).catch((error) => {
                console.error(error);
                this.setState({isFetchingExp: false, expError: true});
            });
        }
        if (query.sfid) {
            prefCentreService.get(query.sfid).then((result) => {
                this.setState({user: result, isFetchingUser: false});
            }).catch((error) => {
                console.error('user error', error);
                this.setState({isFetchingUser: false});
            });
        } else {
            this.setState({isFetchingUser: false});
        }
        gtmPageview(PATH_ADE_WAITLIST);
    }

    onSubmit = (values) => {
        window.scrollTo(0,0);
        this.setState({submitted: true, submittedData: values});
        this.props.history.push(`${PATH_ADE_WAITLIST}${PATH_THANKS}${this.props.location.search}`);
        gtmPageview(`${PATH_ADE_WAITLIST}${PATH_THANKS}`);
    }

    render() {
        const {match, location} = this.props;
        const query = queryString.parse(location.search);
        const {submitted, submittedData, expError, user, isFetchingUser, isFetchingExp} = this.state;
        const theme = query.theme || DEFAULT_THEME;
        var prefillMobile = "";
        if (user && user.mobile && user.mobile.indexOf('04') === 0) {
            prefillMobile = user.mobile.replace(/\s/g, '');
        }

        const fields = [
            {
                node: (<div className="mb-3">
                    <p className="aui-headline-5"><b>{this.state.expCourse}</b></p>
                    <p>{this.state.expLoc}</p>
                    <p>{this.state.expDateFormatted}</p>
                </div>)
            },
            {
                field: FIELD_CHECKBOX,
                name: "otherDates",
                label: "I am interested in alternative dates for this course."
            },
            {
                field: FIELD_CHECKBOX,
                name: "otherLocations",
                label: "I am interested in alternative locations for this course.",
                onChangeFunction: (v,e) => { this.setState({hideFieldTravel: !e.target.checked}); }
            },
            [{
                field: FIELD_DROPDOWN,
                name: "willingToTravel",
                label: "I am willing to travel",
                value: [],
                multiple: true,
                options: STATES_OPTIONS,
                className: this.state.hideFieldTravel ? "d-none" : "",
                colClass: "col-12 col-small-6"
            }],
            [
                {
                    field: FIELD_TEXT,
                    name: "firstName",
                    label: "First name*",
                    value: user.firstName || "",
                    colClass: "col-12 col-tiny"
                },
                {
                    field: FIELD_TEXT,
                    name: "lastName",
                    label: "Last name*",
                    value: user.lastName || "",
                    colClass: "col-12 col-tiny"
                }
            ],
            {
                field: FIELD_TEXT,
                name: "emailAddress",
                label: "Email*",
                value: user.email || ""
            },
            [
                {
                    field: FIELD_TEXT,
                    name: "mobilePhone",
                    label: "Mobile phone*",
                    value: prefillMobile,
                    formatValue: formatMobile,
                    colClass: "col-12 col-small-6"
                },
                {
                    field: FIELD_TEXT,
                    name: "postCode",
                    label: "Postcode*",
                    value: user.postcode || "",
                    colClass: "col-12 col-small-6"
                }
            ],
            {
                field: FIELD_TEXTAREA,
                name: "comment",
                label: "Comments"
            },
            {
                field: FIELD_CHECKBOX,
                name: "adeOptIn",
                label: "I would like to be contacted by Audi Australia with occasional communications on products, offers, news and events. *"
            }
        ];

        return (
            <Layout ui={query.ui || UI_AUDI_MIN} theme={theme} embedded={query.embedded} wide={query.wide}>
                <Helmet>
                    <title>Register your interest for Audi Driving Experience | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page contact-us">

                    {submitted && <div className="mb-5 pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Thank you.</h1>
                        {submittedData.firstName && <p className="mb-3">Dear {submittedData.firstName} {submittedData.lastName},</p>}
                        <p className="mb-5">
                            Thank you for registering your interest for {this.state.expCourse}.
                            We hope to welcome you to one of our driving experiences soon.
                            If there is anything else we can help you with, we encourage you to call our information line on <a href="tel:1300509155" className="aui-textlink">1300 509 155</a> or email <a href="mailto:admin@audidrivingexperience.com.au" className="aui-textlink">admin@audidrivingexperience.com.au</a>.
                        </p>
                        <Button
                            href="https://www.audi.com.au/au/web/en/audi-driving-experience/experiences.html#experiences"
                            variant="secondary"
                            theme={theme === "dark" ? "light" : null}
                        >Return</Button>
                    </div>}

                    {!submitted && !expError && <div className="mb-5 pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Register your interest</h1>

                        {!isFetchingUser && !isFetchingExp && <AudiForm formName="ade-ryi"
                            fields={fields}
                            hiddenFields={{
                                experienceId: match.params.expId,
                                courseName: this.state.expCourse,
                                locationName: this.state.expLoc,
                                date: this.state.expDate
                            }}
                            schema={{
                              adeOptIn: {truthy: { message: "This field is required" }}
                            }}
                            recaptcha
                            preSubmit={(payload) => {
                                if (!payload.otherLocations) {
                                    payload.willingToTravel = [];
                                }
                                return payload;
                            }}
                            onSubmitSuccess={this.onSubmit}
                            style={{maxWidth: "840px"}}
                            theme={theme}
                        />}
                        <p className="mb-3 aui-small">All fields marked with * are mandatory.</p>
                        <Disclaimer theme={theme} />
                    </div>}

                    {expError && <div className="mb-5 pt-3 pt-medium-5">
                        <p className="aui-headline-3 mb-4">Sorry, we couldn't find that experience.</p>
                        <Button
                            href="https://www.audi.com.au/au/web/en/audi-driving-experience/experiences.html#experiences"
                            variant="secondary"
                            theme={theme === "dark" ? "light" : null}
                        >Return</Button>
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default ADEWaitlist;
